export default () => (
  /**
   * Icone de uma barra deslizante.
   * Responsavel por deslizar tela.
   * Utilizado e encontrado apenas no mobile.
   */
  <svg
    width="24"
    height="5"
    viewBox="0 0 24 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.162109" width="24" height="4" rx="2" fill="#D7D7D7" />
  </svg>
);
